import actions from './actions';

const initState = {
  id_token: null,
  access_token: null,
  cdt: 0,
  recoveryVerify: false,
  categoria: 0,
  siigo_token: null,
  siigo_login: false,
  request_siigo: false,
  nivel: "FINAL",
  permisos: null,
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        access_token: action.access_token,
        id_token: action.id_token,
        cdt: action.cdt,
        nombre: action.nombre,
        email: action.email,
        avatar: action.avatar,
        categoria: action.categoria,
        siigoToken: action.siigoToken,
        siigo_login: action.siigo_login,
        verificado: action.verificado,
        notificaciones: action.notificaciones,
        nivel: action.nivel,
        permisos: action.permisos,
      };
    case actions.LOGIN_SUCCESS_SIIGO:
      return {
        ...state,
        siigo_token: action.siigo_token,
        siigo_login: true,
        request_siigo: false
      };
    case actions.UPDATE_LOGIN_INFO:
      return {
        ...state,
        nombre: `${action.profile.nombres} ${action.profile.apellidos}`,
        email: action.profile.email,
        avatar: action.profile.avatar,
      };
    case actions.LOGIN_REQUEST_SIIGO:
      return {
        ...state,
        request_siigo: true
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
